import { ChevronLeft as BackIcon } from 'lucide-react'
import { type OnboardingStep } from './OnboardingFlow'

interface OnboardingProgressProps {
  steps: OnboardingStep[]
  currentStep: OnboardingStep
  onBack?: () => void
}

export default function OnboardingProgress({ steps, currentStep, onBack }: OnboardingProgressProps) {
  const currentIndex = steps.indexOf(currentStep)
  const progress = ((currentIndex + 1) / steps.length) * 100
  const canGoBack = currentIndex > 0

  return (
    <div className="px-6 py-4 mt-4">
      <div className="max-w-md mx-auto">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            disabled={!canGoBack}
            className={`p-1 rounded transition-colors ${
              canGoBack
                ? 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                : 'text-gray-300 cursor-not-allowed'
            }`}
            aria-label="Go back"
          >
            <BackIcon size={16} />
          </button>

          <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-full bg-brand rounded-full transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>

          <span className="text-sm text-gray-500 whitespace-nowrap">
            {currentIndex + 1} of {steps.length}
          </span>
        </div>
      </div>
    </div>
  )
}
